import { Box, Button, FormControlLabel, Switch } from '@mui/material';
import { useState } from 'react';

import FuelGeofencingZipcodes from '@/components/FuelGeofencingZipcodes';
import { useModalContext } from '@/modals/VNModalProvider';
import VnModalBody from '@/modals/components/VnModalBody';
import VnModalFooter from '@/modals/components/VnModalFooter';

export interface BroadcastGeofencingModalResult {
  hasGeofencing: boolean;
  zipcodes: string;
}

interface Props {
  hasGeofencing: boolean;
  zipcodes: string;
  onSave: (result: BroadcastGeofencingModalResult) => void;
}

const BroadcastGeofencingModal = ({ hasGeofencing, zipcodes, onSave }: Props) => {
  const { onClose } = useModalContext();
  const [enabled, setEnabled] = useState<boolean>(Boolean(hasGeofencing));
  const [myZipcodes, setMyZipcodes] = useState<string>(zipcodes ?? '');

  const handleSave = () => {
    onSave({ hasGeofencing: enabled, zipcodes: enabled ? myZipcodes : '' });
    onClose();
  };

  return (
    <div>
      <VnModalBody>
        <FormControlLabel
          control={
            <Switch
              className="fuel-toggle"
              sx={{ marginTop: '-1px', marginLeft: '5px' }}
              inputProps={{ 'aria-label': 'Enable geofencing' }}
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
              size="small"
            />
          }
          label="Enable Geofencing"
          labelPlacement="start"
        />
        {enabled && (
          <Box sx={{ mt: 1, maxHeight: 'calc(100vh - 250px)',
           overflowY: 'auto' }}>
            <FuelGeofencingZipcodes zipcodes={myZipcodes} hasError={false} onChange={setMyZipcodes} />
          </Box>
        )}
      </VnModalBody>
      <VnModalFooter
        right={
          <>
            <Button color="primary" variant="contained" autoFocus onClick={handleSave}>
              Save
            </Button>
            <Button variant="contained" className="cancel-button" onClick={() => onClose()}>
              Cancel
            </Button>
          </>
        }
      />
    </div>
  );
};

export default BroadcastGeofencingModal;
